import { apiDelete, apiGet } from "./base";

import { PAGE_SIZE } from "utils/constants";

interface FetchOpenEncountersParams {
  pageParam?: string;
}

interface SearchEncountersParams {
  pageParam?: string;
  search_query: string;
  user_id: string | null;
}

interface FetchIcdsParams {
  query: string;
  page?: number;
}

interface FetchLabsParams {
  query: string;
  page?: number;
}

interface FetchImagingCodesParams {
  query: string;
  page: number;
}

interface FetchReferralCodesParams {
  query: string;
  page: number;
}

interface FetchProcedureCodesParams {
  query: string;
  page: number;
}

interface FetchEncountersByPatientParams {
  pageParam?: string;
}

export const fetchOpenEncounters = async ({ pageParam }: FetchOpenEncountersParams) => {
  const url = "/api/encounter-recordings/?open=true";
  const response = await apiGet(pageParam ?? url);
  return response.data;
};

export const searchEncounters = async ({ pageParam = undefined, search_query, user_id }: SearchEncountersParams) => {
  const url = `/api/encounter-recordings/search_open/?search_query=${search_query}${user_id !== null ? `&user_ids=${user_id}` : ""}`;
  const response = await apiGet(pageParam ?? url);
  return response.data;
};

export const fetchIcds = async ({ query, page = 1 }: FetchIcdsParams) => {
  const url = `/api/icd10-codes/?query=${query}&page=${page}&page_size=${PAGE_SIZE}`;
  const response = await apiGet(url);
  return response.data;
};

export const fetchLabs = async ({ query, page = 1 }: FetchLabsParams, signal?: AbortSignal) => {
  const url = `/api/compendium-lab-tests/?prefix=${query}&page=${page}&page_size=20`;
  const response = await apiGet(url, signal);
  return response.data;
};

export const fetchImagingCodes = async ({ query, page }: FetchImagingCodesParams) => {
  const url = `/api/imaging-codes/?query=${query}&page=${page}&page_size=20`;
  const response = await apiGet(url);
  return response.data;
};

export const fetchReferralCodes = async ({ query, page }: FetchReferralCodesParams) => {
  const url = `/api/referral-codes/?query=${query}&page=${page}&page_size=20`;
  const response = await apiGet(url);
  return response.data;
};

export const fetchProcedureCodes = async ({ query, page }: FetchProcedureCodesParams) => {
  const url = `/api/procedure-codes/?query=${query}&page=${page}&page_size=20`;
  const response = await apiGet(url);
  return response.data;
};

export const fetchEncountersByPatient = async (patientId: string | number, { pageParam }: FetchEncountersByPatientParams) => {
  const url = `/api/encounters/past-visits/?patient_id=${patientId}`;
  const response = await apiGet(pageParam ?? url);
  return response.data;
};

export interface PriorDiagnosis {
  condition: string;
  icd_10_code: string;
  status: string;
  plan: string[];
  category: string;
}

export const fetchPatientEncounters = async (patientId: string | number, signal?: AbortSignal) => {
  const url = `/api/encounters/past-visits/?page=1&patient_id=${patientId}`;
  const response = await apiGet(url, signal);
  return response.data.results;
};

export const fetchPatientEncs = async (patientId: string | number, signal?: AbortSignal) => {
  const url = `/api/patients/${patientId}/encounters/`;
  const response = await apiGet(url, signal);
  return response.data;
};

export const deleteOpenEncounter = async (encounterId: string | number) => {
  const url = `/api/encounter-recordings/${encounterId}/`;
  const response = await apiDelete(url);
  return response.data;
};

export const bulkDeleteOpenEncounters = async (encounterIds: string[]) => {
  const url = `/api/encounter-recordings/bulk-delete/`;
  const response = await apiDelete(url, { ids: encounterIds });
  return response.data;
};

export const resetDemoData = async (patientId: string | number) => {
  const url = `/api/encounters/reset_demo_data/?patient_id=${patientId}`;
  const response = await apiGet(url);
  return response.data;
};
